(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ip-content-spacing"] && !Shopify.designMode) return;
  try {
    function compactIPRichText(root){
  const selector='.rte,.product__description,.shopify-policy__body';
  const areas=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
  const protectedContent='img,svg,video,audio,iframe,object,embed,input,button,select,textarea,form,table,canvas,[role],a[id],a[name]';
  areas.forEach(area=>{
    Array.from(area.querySelectorAll('p,h1,h2,h3,h4,h5,h6,li,ul,ol')).reverse().forEach(el=>{
      if(!el.textContent.replace(/[\s\u00a0\u200b]/g,'')&&!el.querySelector(protectedContent)&&!el.matches('[role],[aria-live]'))el.remove();
    });
    area.querySelectorAll('br').forEach(br=>{
      const sibling=(direction)=>{
        let next=br[direction];
        while(next&&next.nodeType===3&&!next.textContent.trim())next=next[direction];
        return next;
      };
      if(!sibling('previousSibling')||!sibling('nextSibling')||sibling('previousSibling')?.nodeName==='BR')br.remove();
    });
    area.querySelectorAll('li').forEach(li=>{
      const nested=Array.from(li.children).some(child=>child.matches('div')&&child.querySelector('ul,ol'));
      if(nested&&li.parentElement?.children.length===1){
        li.style.listStyle='none';li.style.paddingLeft='0';
        li.parentElement.style.paddingLeft='0';
      }
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>compactIPRichText(document));else compactIPRichText(document);
document.addEventListener('shopify:section:load',event=>compactIPRichText(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ip-custom-banner-quote"] && !Shopify.designMode) return;
  try {
    function ipUpdateCustomQuote(form){
 const get=key=>form.querySelector('[data-quote="'+key+'"]');
 if(!get('wf'))return false;
 const po=form.querySelector('[data-quote-po]'),art=form.querySelector('input[name="contact[Artwork link (optional)]"]');
 if(po){po.required=!art.value.trim();po.setCustomValidity(po.required&&!po.value.trim()?po.dataset.referenceError:'');}
 const fields=['wf','wi','hf','hi','quantity'].map(get);
 const [wf,wi,hf,hi,q]=fields.map(el=>Number(el.value));
 const w=wf*12+wi,h=hf*12+hi;
 const valid=fields.every(el=>el.value!==''&&el.validity.valid)&&w>0&&h>0&&Number.isInteger(q)&&q>0;
 form.querySelector('[data-quote-error]').hidden=valid;
 form.querySelector('button[type=submit]').disabled=!valid;
 const summary=form.querySelector('[data-quote-summary]');
 if(!valid){form.querySelectorAll('[data-quote-output]').forEach(el=>el.textContent='—');summary.value='';return false;}
 const base=Math.max(9999,Math.round(w*h*375/144));
 const extras=Array.from(form.querySelectorAll('[data-quote-extra]:checked')).reduce((n,el)=>n+Number(el.dataset.quoteExtra),0);
 const values={base,extras,unit:base+extras,total:(base+extras)*q};
 const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n/100);
 form.querySelectorAll('[data-quote-output]').forEach(el=>el.textContent=money(values[el.dataset.quoteOutput]));
 summary.value='CUSTOM VINYL BANNER — ESTIMATE ONLY\nSize: '+wf+' ft '+wi+' in wide × '+hf+' ft '+hi+' in high\nQuantity: '+q+'\nBase per banner: '+money(base)+'\nFinishing per banner: '+money(extras)+'\nEstimated unit price: '+money(values.unit)+'\nEstimated subtotal: '+money(values.total)+'\nBefore discounts, shipping and tax. Final price must be verified and approved by IMPRINTS IP before invoicing. Finishing selections and artwork notes accompany this request.';
 return !po||po.checkValidity();
}
function ipInitCustomQuotes(){document.querySelectorAll('.ip-custom-quote-form').forEach(ipUpdateCustomQuote);}
document.addEventListener('input',event=>{const form=event.target.closest('.ip-custom-quote-form');if(form)ipUpdateCustomQuote(form);});
document.addEventListener('change',event=>{const form=event.target.closest('.ip-custom-quote-form');if(form)ipUpdateCustomQuote(form);});
document.addEventListener('submit',event=>{if(!event.target.matches('.ip-custom-quote-form'))return;const po=event.target.querySelector('[data-quote-po]');if(po)po.value=po.value.trim();if(!ipUpdateCustomQuote(event.target)){event.preventDefault();event.target.reportValidity();}});
document.addEventListener('reset',event=>{if(event.target.matches('.ip-custom-quote-form'))setTimeout(()=>ipUpdateCustomQuote(event.target),0);});
document.addEventListener('DOMContentLoaded',ipInitCustomQuotes);
document.addEventListener('shopify:section:load',ipInitCustomQuotes);
if(document.readyState!=='loading')ipInitCustomQuotes();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ip-sample-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
const initialize=()=>{
document.querySelectorAll('.ip-samples').forEach(root=>{
if(root.dataset.samplesInitialized)return;
const track=root.querySelector('.ip-samples-track'),pause=root.querySelector('[data-pause]');
if(!track||!pause)return;
root.dataset.samplesInitialized='true';
const motion=matchMedia('(prefers-reduced-motion: reduce)');
let stopped=motion.matches,hover=false;
const step=direction=>{const card=track.querySelector('.ip-sample');if(!card)return;const end=track.scrollWidth-track.clientWidth;let left=track.scrollLeft+direction*(card.offsetWidth+18);if(left>end+5)left=0;if(left<0)left=end;track.scrollTo({left,behavior:motion.matches?'instant':'smooth'});};
const update=()=>{pause.textContent=stopped?root.dataset.play:root.dataset.pause;pause.setAttribute('aria-pressed',String(stopped));};
root.querySelector('[data-prev]').addEventListener('click',()=>step(-1));
root.querySelector('[data-next]').addEventListener('click',()=>step(1));
pause.addEventListener('click',()=>{stopped=!stopped;update();});
track.addEventListener('mouseenter',()=>hover=true);
track.addEventListener('mouseleave',()=>hover=false);
track.addEventListener('pointerdown',()=>{stopped=true;update();});
const onMotionChange=()=>{if(motion.matches){stopped=true;update();}};
motion.addEventListener('change',onMotionChange);
const timer=setInterval(()=>{
if(!root.isConnected){clearInterval(timer);motion.removeEventListener('change',onMotionChange);return;}
if(!stopped&&!hover&&!document.hidden&&!track.contains(document.activeElement))step(1);
},3000);
update();
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
